import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import { OfferConfig } from "../../../../features/offer/types/offer-config.ts";

export const getConfigReducer = (
  state: LoanState,
  action: PayloadAction<OfferConfig>,
) => {
  state.config = action.payload;
};
